var changeTabIndex = (index) => {
  return function (dispatch) {
    dispatch({ type: "TAB_INDEX", payload: { 'tabIndex': index} });
  };
}

export default { 'TAB_INDEX': changeTabIndex };


// WEBPACK FOOTER //
// ./src/actions/chat_actions.js